import React from "react";
import { Social } from "../../../store/services/invitations/dto/invitations.dto";
import { Box, FormControl, Button, RadioGroup, FormControlLabel, Radio, TextField, IconButton } from "@mui/material";
import { Delete, Add } from "@mui/icons-material";
import { SocialMediaWrapper } from "./styles";
import { v4 as uuidv4 } from "uuid";
import { cloneDeep } from "lodash";

const SOCIAL_MEDIA_RADIO_LIST = [
	{ label: "Instagram", val: 1 },
	{ label: "Facebook", val: 2 },
	{ label: "Tiktok", val: 3 }
];

const NEW_SOCIAL_MEDIA = {
	social_type: 1,
	value: ""
};
const MAX_SOCIAL_MEDIA = 3;
const SocialMedia = ({
	fieldValueState,
	setFieldValueState
}: {
	fieldValueState: Social[];
	setFieldValueState: React.Dispatch<React.SetStateAction<Social[]>>;
}) => {
	const handleAddNewSocialMedia = () => {
		setFieldValueState(prevState => [...prevState, { ...NEW_SOCIAL_MEDIA, _id: uuidv4() }] as Social[]);
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
		setFieldValueState(prevState => {
			const oldList = cloneDeep(prevState);
			const index = oldList.findIndex(o => o._id === id);
			oldList[index].social_type = +e.target.value;
			return oldList;
		});
	};

	const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, id: string) => {
		setFieldValueState(prevState => {
			const oldList = cloneDeep(prevState);
			const index = oldList.findIndex(o => o._id === id);
			oldList[index].value = e.target.value;
			return oldList;
		});
	};

	const handleDeleteSocial = (id: string) => {
		setFieldValueState(prevState => [...prevState].filter(item => item._id !== id));
	};

	return (
		<SocialMediaWrapper gap={2}>
			{fieldValueState.map(mediaItem => (
				<Box
					key={mediaItem._id}
					display="flex"
					flexDirection="column"
					gap={1}
					style={{ border: mediaItem.hasError ? "1px solid red" : "" }}
				>
					<Box display="flex" flexDirection="row">
						<FormControl>
							<RadioGroup
								row
								aria-labelledby="demo-row-radio-buttons-group-label"
								name="row-radio-buttons-group"
								value={mediaItem.social_type}
								onChange={e => handleChange(e, mediaItem._id)}
							>
								{SOCIAL_MEDIA_RADIO_LIST.map(item => (
									<FormControlLabel key={item.label} value={item.val} control={<Radio />} label={item.label} />
								))}
							</RadioGroup>
						</FormControl>
						<IconButton onClick={() => handleDeleteSocial(mediaItem._id)}>
							<Delete />
						</IconButton>
					</Box>
					<TextField
						value={mediaItem.value}
						placeholder={"handle"}
						label={"Link"}
						onChange={e => handleTextChange(e, mediaItem._id)}
					/>
				</Box>
			))}

			<Button
				variant={"outlined"}
				color={"primary"}
				onClick={handleAddNewSocialMedia}
				disabled={fieldValueState.length === MAX_SOCIAL_MEDIA}
			>
				<Add />
			</Button>
		</SocialMediaWrapper>
	);
};

export default SocialMedia;
